import React from 'react';
import Hero from '../components/membership/Hero';
import MembershipConsiderations from '../components/membership/MembershipConsiderations';

export default function Membership() {    

    return (
        <>
            <Hero/>
            <MembershipConsiderations/>
        </>
    );
}